module.exports = __webpack_public_path__ + "2721ecb3e87f2fb9bfe47a1c1306ed2f.png";